import { Send } from '@mui/icons-material';
import React from 'react'
import styled from "styled-components"
import {mobile} from "../responses"
import { Link } from 'react-router-dom';
import { keyframes } from 'styled-components'
const breatheAnimation = keyframes`
 0% {  width: 0%; left:0}
 100% { width: 100%; left:0%}
`

const Container=styled.div`
    height:80vh;
    background-color:#fcf5f5;    
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    ${mobile({height:"60vh"})};
`
const Title=styled.h1`
    font-size:50px;
    margin-bottom:20px;
    ${mobile({fontSize:"40px"})};

    `
    const Description=styled.div`
    font-size:24px;
    margin-bottom:20px;
    position: relative;
    font-weight:300;
    ${mobile({textAlign:"center"})};

    &::before{
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        border-radius: 12px;
        background-color: #887dd1;
        top: 100%;
        animation: ${breatheAnimation} 3s alternate 1 forwards;
        
    }
`
const InputContainer=styled.div`
    width:50%;
    height:40px;
    background-color:white;
    display: flex;
    justify-content: space-between;
    border: 1px solid lightgray;
    ${mobile({width:"40%",justifyContent:"center"})};

`
const Input=styled.input`
    border: none;
    flex: 8;
    padding-left: 20px;
`
const Button=styled.button`
    flex: 1;
    border: none;
    background-color: #887dd1;
    color: white;
`
const Img=styled.img`
    border-radius: 10px;
    width: 50%;
    height: 60%;
    object-fit: cover;
    margin-bottom: 10px;
    ${mobile({width:"70%",justifyContent:"center"})};
    object-position: 100% 30%;
`
const NewsLetter = () => {
  return (
    <Container>
        <Title>About The Developer</Title>
        <Description>Vivekanand Ojha, Full-Stack Developer</Description>
        <Img src="https://i.ibb.co/4RbKDh6/Whats-App-Image-2023-08-26-at-11-54-34.jpg" alt="" />
        <InputContainer>
            <div style={{flex:"5",textAlign:"center",lineHeight:"40px",fontSize:"20px",fontWeight:"500"}}>Portfolio</div>
            <Button
                style={{color:"white",cursor:"pointer"}}
            >
                <Link to={"https://funny-truffle-75736f.netlify.app/"}
                target='_blank'
                style={{color:"white",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between"}}
                >
                <span>visit</span>
                    <Send/>
                </Link>
            </Button>
        </InputContainer>
      
    </Container>
  )
}

export default NewsLetter
